// CRM layer — "تحويل متابعة" form (added Phase 6-B).
// Hand a follow-up to a department or a named colleague. The note is mandatory.

import React, { useEffect, useState } from 'react';
import { crmCreateTransfer, crmGetTypes, crmGetUserDepartments } from './crmApi';

const CrmTransferModal = ({ phoneNumber, sourceCallId, onClose, onDone }) => {
  const [departments, setDepartments] = useState([]);
  const [agents, setAgents] = useState([]);
  const [toDepartment, setToDepartment] = useState('');
  const [toExtension, setToExtension] = useState('');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Departments come from the type catalogue (each type owns one).
    crmGetTypes()
      .then((r) => setDepartments([...new Set(r.data.types.map((t) => t.department).filter(Boolean))]))
      .catch(() => {});
    // Colleagues who already have a department mapping are valid direct targets.
    const token = localStorage.getItem('token');
    fetch('/api/auth/users', { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((d) => setAgents(Array.isArray(d) ? d.filter((u) => u.extension) : []))
      .catch(() => {});
    crmGetUserDepartments().catch(() => {});
  }, []);

  const submit = async () => {
    setError('');
    if (!note.trim()) { setError('الملاحظة إجبارية عند تحويل المتابعة'); return; }
    if (!toDepartment && !toExtension) { setError('يجب تحديد قسم أو موظف'); return; }
    setSaving(true);
    try {
      await crmCreateTransfer({
        phone: phoneNumber,
        to_department: toDepartment || undefined,
        to_extension: toExtension || undefined,
        note,
        source_call_id: sourceCallId || undefined
      });
      if (onDone) onDone();
      onClose();
    } catch (e) {
      setError(e.response?.data?.error || 'فشل التحويل');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay crm-calm" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 520 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>تحويل متابعة</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <p className="crm-modal-note" style={{ marginBottom: 14 }}>
            حوّل متابعة الرقم <b style={{ direction: 'ltr', display: 'inline-block' }}>{phoneNumber}</b> لقسم آخر
            أو لموظف محدد. أول من يستلم التحويل يصبح مسؤولاً عنه.
          </p>

          <div style={{ marginBottom: 12 }}>
            <label className="crm-modal-label">إلى قسم</label>
            <select className="filter-select" style={{ width: '100%' }} value={toDepartment}
              onChange={(e) => setToDepartment(e.target.value)}>
              <option value="">— بدون —</option>
              {departments.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>

          <div style={{ marginBottom: 12 }}>
            <label className="crm-modal-label">أو إلى موظف محدد</label>
            <select className="filter-select" style={{ width: '100%' }} value={toExtension}
              onChange={(e) => setToExtension(e.target.value)}>
              <option value="">— بدون —</option>
              {agents.map((a) => (
                <option key={a.extension} value={a.extension}>{a.fullName} ({a.extension})</option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: 12 }}>
            <label className="crm-modal-label">سبب التحويل (إجباري)</label>
            <textarea className="filter-input" style={{ width: '100%', minHeight: 90 }}
              placeholder="لماذا تحوّل هذه المتابعة؟ ماذا يحتاج العميل؟"
              value={note} onChange={(e) => setNote(e.target.value)} />
          </div>

          {error && <div className="crm-modal-err">{error}</div>}
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" disabled={saving} onClick={submit}>
            {saving ? 'جارٍ التحويل...' : 'تحويل'}
          </button>
          <button className="btn btn-outline" onClick={onClose}>إلغاء</button>
        </div>
      </div>
    </div>
  );
};

export default CrmTransferModal;
